export default __webpack_public_path__ + "c4753368094c05feba2026da70187b34.png";